import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params, PRIMARY_OUTLET } from '@angular/router';

interface IBreadcrumb {
  label: string;
  params: Params;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: IBreadcrumb[];
  @Input() url: string;
  @Input() queryParams = {};
  @Input() urlMain = '';

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
    this.breadcrumbs = [];
    this.urlMain = '';
  }

  ngOnInit() {
    this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root);
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      const routeURL = `${this.urlMain}/${child.snapshot.url.map(segment => segment.path).join('/')}`;

      url += `${routeURL}`;

      const breadcrumb: IBreadcrumb = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
        params: child.snapshot.params,
        url: url
      };
      breadcrumbs.push(breadcrumb);

      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
  }

}
